import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MagirusTicketModelDto } from '../dto/magiurs/magirus-ticket-model.dto';

@Injectable({
    providedIn: 'root'
})
export class MagirusBalmungService {

    private apiUrl = `${environment.apiUrl}/magirus-balmung`;

    constructor(private http: HttpClient) { }

    getClientsByTerm(searchTerm: string): Observable<any> {
        console.log('term', searchTerm);
        let ret = this.http.get<any>(`${this.apiUrl}/clients/search`, { params: { searchTerm } });
        return ret;
    }

    getClients(searchTerm?: string): Observable<HttpResponse<any>> {
        let params = new HttpParams();
        if (searchTerm) {
            params = params.set('search', searchTerm);
        }
        return this.http
            .get<any>(`${this.apiUrl}/clients`, { observe: 'response', params });
    }

    getClientByEmail(email: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/client/by-email?email=${email}`);
    }

    generateOffer(body: { formId: string; name: string }): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/offer`, body);
    }

    /**
     * Create a lead (pre-stage for an offer). Only requires formId in the body.
     * Expected response: { taskId, clientId, contactId }
     */
    generateLead(body: { formId: string }): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/lead`, body);
    }

    getAmountOfOfferPositions(offerId: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/offer-positions?offerId=${offerId}`);
    }

    generateTicket(ticketDto: MagirusTicketModelDto) {
        return this.http.post<any>(`${this.apiUrl}/ticket`, ticketDto);
    }

    getContactsForClient(clientId: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/client/contacts`, { params: { clientId } });
    }

    startProductSync() {
        let retval = this.http.post<any>(`${this.apiUrl}/sync-products`, {});
        return retval;
    }

    syncBundles() {
        let retval = this.http.post<any>(`${this.apiUrl}/sync-bundles`, {});
        return retval;
    }

    assignBalmungTags() {
        let retval = this.http.post<any>(`${this.apiUrl}/assign-balmung-tags`, {});
        return retval;
    }

    // Custom fields for clients and contacts
    getClientCustomFields(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/custom-fields/all/client`);
    }


    getContactCustomFields(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/custom-fields/all/contact`);
    }

    /**
     * Get calculation details for an offer
     * Example: GET /magirus-balmung/offer/calc?offerId=...
     */
    getOfferCalc(offerId: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/offer/calc`, { params: { offerId } });
    }

    /**
     * Get all offers for searching
     * Example: GET /magirus-balmung/offers
     */
    getOffers(searchTerm?: string): Observable<any> {
        let params = new HttpParams();
        if (searchTerm) {
            params = params.set('search', searchTerm);
        }
        return this.http.get<any>(`${this.apiUrl}/offers`, { params });
    }

}
